import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import Fingerprint2 from '@fingerprintjs/fingerprintjs'
// let ApiVersion = "v1.0.7"  // 接口版本号
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000000, // request timeout
  // 添加Content-Type = 'application/json'
  headers: {
    'Content-Type': 'application/json'
    // 'Api-Version': ApiVersion
  }
})
// request interceptor
let visitorId = ''
Fingerprint2.load().then(fp => {
  fp.get().then(result => {
    visitorId = result.visitorId
  })
})
service.interceptors.request.use(
  config => {
    // 解决get添加不了请求头问题
    if (config.method === 'get') {
      config.data = { unused: 0 }
    }
    if (store.getters.token) {
      config.headers['Access-Token'] = getToken()
      config.headers['Fingerprint'] = visitorId
    }
    if (config.url.indexOf('/api/manage') !== -1) {
      config.headers['Api-Version'] = 'v1.6.5'
    } else if (config.url.indexOf('/api/iot') !== -1) {
      config.headers['Api-Version'] = 'v1.2.7'
    }else if (config.url.indexOf('/openapi/common') !== -1  ||  config.url.indexOf('/api/common') !== -1) {
      config.headers['Api-Version'] = 'v1.2.1'
    }
    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data

    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 200) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      // 处理各种异常抛出
      if (res.code === 1001) {
        // to re-login
        MessageBox.confirm('用户标识信息已失效,请重新登录或者留在本页', {
          confirmButtonText: '重新登陆',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
